import { SVGProps, useMemo } from 'react';

import { useTheme } from '@/features/theme-switch';

const Arrow = (props: SVGProps<SVGSVGElement>) => {
  const { darkTheme } = useTheme();

  const color = useMemo(() => (darkTheme ? '#FFFFFF' : '#A0A8AA'), [darkTheme]);

  return (
    <svg
      width={20}
      height={20}
      fill="none"
      viewBox="0 0 20 20"
      stroke={color}
      {...props}
    >
      <path
        stroke="current"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.667 5.833 7.5 10l4.167 4.167"
      />
    </svg>
  );
};
export default Arrow;
